type Version = `1.${number}`;

// * Version list
export const legacyVersion: Version = '1.0';
export const newOrderVersion: Version = '1.1';
export const dealerModeVersion: Version = '1.2';
